import { EStorageType } from 'reactApp/modules/storage/storage.types';

export const trashbinCrumb = [
    {
        name: 'Корзина',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.trashbin,
    },
];

export const favoritesCrumb = [
    {
        name: 'Избранные',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.favorites,
    },
];

export const recomendCrumb = [
    {
        name: 'VK рекомендует',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.recommend,
    },
];

export const feedCrumb = [
    {
        name: 'Последние файлы',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.feed,
    },
];

export const galleryCrumb = [
    {
        name: 'Галерея',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.gallery,
    },
];

export const autodeleteCrumb = [
    {
        name: 'Автоудаляемые',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.sharedAutodelete,
    },
];

export const familyCrumb = [
    {
        name: 'Общая подписка',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.family,
    },
];
export const familyFoldersCrumb = [
    {
        name: 'Семья',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.familyFolders,
    },
];

export const familyAlbumsCrumb = [
    {
        name: 'Семья',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.familyAlbums,
    },
];

export const vigboCrumb = [
    {
        name: 'Галереи Vigbo',
        id: '/',
        kind: 'storage' as const,
        storage: EStorageType.vigbo,
        showIcon: false,
    },
];

export const duplicatesCrumb = [
    {
        name: 'Альбомы',
        id: '/albums',
        kind: 'storage' as const,
        storage: EStorageType.albums,
    },
    {
        name: 'Дубликаты',
        id: '/albums/duplicates' as const,
        storage: EStorageType.duplicates,
        kind: 'folder' as const,
    },
];
